import type { ReactNode } from 'react';
import React, { useMemo } from 'react';
import { useStyletron } from 'baseui';
import type { StyleObject } from 'styletron-react';
import AnimationContainer from './animation-container';
type PropsT = {
  isOpen: boolean;
  children: ReactNode;
  direction?: 'right' | 'bottom';
  id?: string;
  styles?: StyleObject;
};
const animationContainerStyles = theme => ({
  position: 'absolute',
  top: 0,
  right: 0,
  height: '100%',
  width: '100%',
  padding: theme.sizing.scale500,
  backgroundColor: theme.colors.backgroundPrimary,
  boxShadow: theme.lighting.shadow700,
  boxSizing: 'border-box',
  ...theme.borders.border300,
  display: 'flex',
  flexDirection: 'column'
});
function SideDrawer({
  isOpen,
  children,
  id,
  styles,
  direction = 'right'
}: PropsT) {
  const [, theme] = useStyletron();
  const {
    enterStyle,
    exitStyle
  }: {
    enterStyle: StyleObject;
    exitStyle: StyleObject;
  } = useMemo(() => {
    switch (direction) {
      case 'bottom':
        {
          return {
            enterStyle: {
              transform: 'translateY(100%)'
            },
            exitStyle: {
              transform: 'translateY(0%)'
            }
          };
        }
      case 'right':
        {
          return {
            enterStyle: {
              transform: 'translateX(100%)'
            },
            exitStyle: {
              transform: 'translateX(0%)'
            }
          };
        }
    }
  }, [direction]);
  return <AnimationContainer isOpen={isOpen} styles={{
    ...animationContainerStyles(theme),
    ...styles
  }} enterStyle={enterStyle} exitStyle={exitStyle} duration={500} id={id}>
      {children}
    </AnimationContainer>;
}
export default SideDrawer;